exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LoginInput__input___2SyDA {\n  border: none;\n  background: #8c9fed;\n  color: white;\n  padding: 16px;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  width: 100%;\n  min-width: 255px;\n}\n\n.LoginInput__input___2SyDA::-webkit-input-placeholder {\n  color: white;\n}\n\n.LoginInput__input___2SyDA:-ms-input-placeholder {\n  color: white;\n}\n\n.LoginInput__input___2SyDA::-ms-input-placeholder {\n  color: white;\n}\n\n.LoginInput__input___2SyDA::placeholder {\n  color: white;\n}\n\n.LoginInput__input___2SyDA {\n  margin-bottom: 16px;\n}\n", ""]);

// exports
exports.locals = {
	"input": "LoginInput__input___2SyDA"
};